export class UnitConversionUtil {
  public static transformKiloMetersToMeters(inputNumber: number): number {
    return parseFloat(inputNumber.toFixed(2)) * 1000;
  }

  public static transformMetersToKiloMeters(inputNumber: number): number {
    return inputNumber / 1000;
  }
}
